import styled from 'styled-components';

const Button = styled.button`
  background: linear-gradient(166deg, rgb(48, 59, 113) 17%, rgb(43, 47, 66) 100%);
  color: white;
  width: 100%;
  padding: 10px;
  border-radius: 15px;
  transition: transform 0.5s ease;
  margin: 10px;
  user-select: none;
  &:hover {
    background: linear-gradient(90deg, rgb(48, 59, 113) 17%, rgb(43, 47, 66) 100%);
  }
  &:active {
    transform: scale(0.91);
  }
`;

export default {
  Button,
};
